import { useNavigate, useLocation, Link } from "react-router-dom";
import { Zap, LogOut, LayoutGrid, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function TopNav() {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <header className="fixed inset-x-0 top-0 z-50 h-16 border-b border-slate-200 bg-white">
      <div className="mx-auto flex h-full max-w-[1500px] items-center justify-between px-6">
        <Link to="/devices" className="flex items-center gap-2.5" data-testid="nav-logo">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-blue-600">
            <Zap size={18} className="text-white" fill="white" />
          </span>
          <div className="leading-none">
            <div className="font-display text-sm font-extrabold tracking-tight text-slate-900">
              VIWAT MONITOR
            </div>
            <div className="text-[10px] font-medium uppercase tracking-[0.15em] text-slate-400">
              Портал накопичення енергії
            </div>
          </div>
        </Link>

        <nav className="flex items-center gap-1">
          <Link
            to="/devices"
            data-testid="nav-devices"
            className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
              pathname.startsWith("/devices")
                ? "bg-blue-50 text-blue-700"
                : "text-slate-600 hover:bg-slate-50"
            }`}
          >
            <LayoutGrid size={16} />
            Прилади
          </Link>
          {user?.role === "admin" && (
            <Link
              to="/admin"
              data-testid="nav-admin"
              className={`flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                pathname.startsWith("/admin")
                  ? "bg-blue-50 text-blue-700"
                  : "text-slate-600 hover:bg-slate-50"
              }`}
            >
              <ShieldCheck size={16} />
              Адмін
            </Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          <div className="hidden text-right sm:block">
            <div className="text-xs font-medium text-slate-700">{user?.email}</div>
            <div className="text-[10px] uppercase tracking-wide text-slate-400">
              {user?.role}
            </div>
          </div>
          <button
            data-testid="logout-btn"
            onClick={() => {
              signOut();
              navigate("/login");
            }}
            className="flex items-center gap-2 rounded-md border border-slate-200 px-3 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-50"
          >
            <LogOut size={16} />
            Вийти
          </button>
        </div>
      </div>
    </header>
  );
}
